import React from 'react';
import Tilt from 'react-tilt'
import { useParams } from 'react-router-dom';

import EventDescription from '../components/EventDescription'
import Banner from '../components/Banner'
import Prizes from '../components/Prizes'
import Timeline from '../components/Timeline'
import Registration from '../components/Registration'
import Breaker from '../components/Breaker'

import '../assets/css/event.css';
import eventsData from '../eventsData';
import AnimatedBackground from '../components/AnimatedBackground';
import Prizes_new from '../components/Prizes_new';
import Navbar2 from '../components/Navbar';
import Speakers from '../components/Speakers';


function Event() {
  
  let params = useParams();
  let name;
  
  if (params.id){
    name = params.id
  }
  else{
    name = 'sociopreneurs'
  }
  console.log("INSIDE EVENTS PAGE",params)
 
  var events = eventsData.filter(function(obj) {
    return obj.name==name;
  });

  console.log("EVENTS => ",events)
  
  const getData = events[0]

  
 
  return (

    <div>
        <img src={getData.poster}  style={{width:"80%",display:"block",marginLeft:"auto",marginRight:"auto"}} alt=""></img>

        {/* POSTER */}
       

        {/* REGISTRATION LINK */}
        <div className='btn'>
            <a href="https://www.kaizeniitd.in"><h3 style={{color: 'gray'}}>Home</h3></a>
        </div>                         
       </div>
  )
}

export default Event